import React, { useState } from "react";
import { Tabs, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box, IconButton, styled, Checkbox, MenuItem, Select, useTheme, Skeleton } from "@mui/material";
import alignCenter from "assets/icons/aligncenter.svg";
import { IoIosArrowDown } from "react-icons/io";
import { useGetIssuesTimeImpactQuery, useGetIssuesCostImpactQuery } from '../../../store/slices/apis/issuesDashboardSlice';
import { useParams } from "react-router-dom";

const StyledTableHead = styled(TableCell)(({ theme }) => ({
  fontWeight: "400", fontSize: '12px', color: '#37352F', padding: '4px 10px 4px 10px', lineHeight: '100%'
}));

const StyledTableRow = styled(TableCell)(({ theme }) => ({
  fontWeight: "400", fontSize: '12px', color: '#000000', padding: '14px 10px 8px 20px', lineHeight: '100%',
  border: 'none'
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: "none", // Prevent uppercase
  fontWeight: "400",
  fontSize: "16px",
  color: "#696969",
  lineHeight: "24px",
  letterSpacing: "0.4px",
  padding: '0px',
  minHeight: '0px',
  minWidth: '0px',
  margin: '10px 20px 5px 5px',
  "&.Mui-selected": {
    color: `${theme?.customSettings?.themeColor}`, fontWeight: "bold"
  },
}));


const OpenIssuesTimeCostImpact = () => {
  const { projectId } = useParams();
  const theme = useTheme();

  const { data: IssuesTimeImpact = [], error, isLoading } = useGetIssuesTimeImpactQuery({
    projectId: projectId
  });

  const { data: IssuesCostImpact = [] } = useGetIssuesCostImpactQuery({
    projectId: projectId
  });

  const timecostdata = {

    timeimpactData: IssuesTimeImpact?.data?.map((item, index) => ({
      issue: item.issueName,
      module: item.module,
      timeimpact: item.totalTimeImpact,
    })),

    costimpactData: IssuesCostImpact?.data?.map((item, index) => ({
      issue: item.issueName,
      module: item.module,
      costimpact: `₹${item.totalCostImpact}`,
    })),

  };

  const [tabIndex, setTabIndex] = useState(0);
  const handleChange = (_, newValue) => {
    setTabIndex(newValue);
  };

  const columnstime = ["Issue Name", "Module", "Time Impact (Days)"];
  const columnscost = ["Issue Name", "Module", "Cost Impact (INR)"];
  const currentData = tabIndex === 0 ? timecostdata.timeimpactData : timecostdata.costimpactData;
  const currentColumn = tabIndex === 0 ? columnstime : columnscost;

  if (isLoading) {
    return (
      <Paper sx={{ boxShadow: 'none', minHeight: '740px' }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableHead colSpan={8} sx={{ padding: 0 }}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={0}>
                      <StyledTab label="Time Impact" />
                      <StyledTab label="Cost Impact" />
                    </Tabs>
                  </Box>
                </StyledTableHead>
              </TableRow>
              <TableRow>
                {[...Array(3)].map((_, idx) => (
                  <StyledTableHead key={idx}>
                    <Skeleton variant="text" width={100} height={16} />
                  </StyledTableHead>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {[...Array(15)].map((_, rowIdx) => (
                <TableRow key={rowIdx}>
                  {[...Array(3)].map((_, colIdx) => (
                    <StyledTableRow key={colIdx}>
                      <Skeleton variant="text" width={colIdx === 0 ? "400px" : "100%"} height={20} />
                    </StyledTableRow>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    );
  }


  return (
    <Paper sx={{ boxShadow: 'none', minHeight: '740px' }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableHead colSpan={8} sx={{ padding: 0 }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs value={tabIndex} onChange={handleChange} sx={{
                    minHeight: "0px",
                    "& .MuiTabs-indicator": { backgroundColor: `${theme?.customSettings?.themeColor}` },
                    "&.Mui-selected": {
                      color: `${theme?.customSettings?.themeColor}`, fontWeight: "bold"
                    },
                  }}>
                    <StyledTab label="Time Impact" sx={{ textTransform: 'none' }} />
                    <StyledTab label="Cost Impact" sx={{ textTransform: 'none' }} />
                  </Tabs>
                </Box>
              </StyledTableHead>
            </TableRow>
          </TableHead>
          <TableHead>
            <TableRow>

              {currentColumn?.map((column) => (
                <StyledTableHead key={column}>
                  <IconButton>
                    <img src={alignCenter} style={{
                      height: '9px',
                      width: '9px'
                    }} />
                  </IconButton>
                  {column}
                </StyledTableHead>
              ))}

            </TableRow>
          </TableHead>
          <TableBody>
            {currentData?.map((row, index) => {
              return (
                <TableRow key={index}>
                  <StyledTableRow>{row.issue}</StyledTableRow>
                  <StyledTableRow>{row.module}</StyledTableRow>
                  {tabIndex == 0 ? <StyledTableRow>{row.timeimpact}</StyledTableRow> : <StyledTableRow>{row.costimpact}</StyledTableRow>}
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default OpenIssuesTimeCostImpact;
